import React from 'react';
import { Outlet } from "react-router";
import { Link } from 'react-router-dom';
import MyButton from './MyButtton.js';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import ImportExportDataPanel from './ImportExportDataPanel.js';
import CloudDataPanel from './CloudDataPanel.js';
import UtilitySidebar from './UtilitySidebar.js';
import './App.css';
import logo from './tao_mountain5.jpg';
import { ChecklistRtl, ChevronLeft, ChevronRight, EditCalendarOutlined, EmojiEventsOutlined, FormatListNumbered, History, HomeOutlined, ImportExport, LandscapeOutlined, ManageSearchOutlined } from '@mui/icons-material';
import { Button, rgbToHex } from '@mui/material';
import Box from '@mui/material/Box';
import SimpleBottomNavigation from './Tree/components/SimpleBottomNavigation.js';
import MenuFab from './Tree/components/MenuFab.jsx';
import { addTask } from './Tree/utilities.ts';

import Divider from '@mui/material/Divider';
import {default as MUIMenu} from '@mui/material/Menu';
import {default as MUIMenuItem} from '@mui/material/MenuItem';
import { ContentCopy, Delete, EmojiEvents, ExpandMore, ExpandLess, MoreHoriz, EditCalendar } from '@mui/icons-material';
import { ListItemIcon } from '@mui/material';

function App({
  items,
  setItems,
  selectedItem,
  setSelectedItem,
  specifiedCurrentUserId, // #FIXME this is a hack. we really want to be making sure were using 
                   // the id of logged in user as defined by auth, not whatever is passed in
                   // here at render time...
  signOut
}) {

  const [navMenuCollapsed, setNavMenuCollapsed] = React.useState(false);

  console.log('Do we get here?: '+items);

  function handleLogOutCLick() {
    localStorage.setItem("Authenticated", false);
    console.log('setIsLoggedIn: ' + signOut);
    signOut();
  }

  function createTask() {
    addTask(items, setItems);
  };

  const id = React.useId();
  const buttonId = `${id}-button`;
  const menuId = `${id}-menu`;
  const [topMeuAanchorEl, setTopMenuAnchorEl] = React.useState(null);
  const open = Boolean(topMeuAanchorEl);

  const handleContextMenuClick = (event) => {
    event.preventDefault();
    setTopMenuAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    // event.preventDefault();
    // event.stopPropagation();
    setTopMenuAnchorEl(null);
  };

  const handleMenuOpen = (e) => {
    // 💡 Isolate the tap completely to prevent focus propagation loops
    e.preventDefault();
    e.stopPropagation();
    setTopMenuAnchorEl(e.currentTarget);
  };

  return (

    <div className="App-Page">
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%', minHeight: 0, overflow: 'hidden' }}>
        <Box component="header" sx={{ height: '37px' }}>
          <div className='App-Header' >
            <div className='App-Logo'>
              {!navMenuCollapsed && <img className="App-LogoImage" src={logo} alt="Logo"/>}
              {navMenuCollapsed && <img className="App-LogoImageCollapsed" src={logo} alt="Logo"/>}
            </div>
            <Box
              component="header"
              sx={{
                display: { xs: 'none', md: 'block' },
                minHeight: 0, overflow: 'hidden'                
              }}
            >
              <div className='App-Omnibox'>
                {/*TODO: Update these to handle no items/ensure they can handle undefined 'items'*/}
                <MyButton items={items} 
                          setItems={setItems} 
                          specifiedCreatedTaskOwnerId={specifiedCurrentUserId}
                          // goal={selectedTaskTier === taskTiers[2] ? true: false}
                          // goal={false}
                          // primaryLabel={(selectedPrimaryLifeArea && selectedPrimaryLifeArea.name === primaryLifeAreas[10].name)? primaryLifeAreas[0].name : selectedPrimaryLifeArea? selectedPrimaryLifeArea.name: primaryLifeAreas[0].name} 
                />
              </div>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', }}>
              <Button
                id={buttonId}
                aria-controls={open ? menuId : undefined}
                aria-haspopup="true"
                aria-expanded={open}
                onMouseDown={handleMenuOpen}
                onClick={(e) => handleContextMenuClick(e)}
                onTouchEnd={handleContextMenuClick}
                sx={{
                  color: '#d7d8dadc',        
                }}
              >
                <MoreHoriz />
              </Button>
              <MUIMenu
                id={menuId}
                anchorEl={topMeuAanchorEl}
                open={open}
                onClose={(e) => handleClose(e)}
                disablePortal
                autoFocus={false}
                disableAutoFocusItem
                disableRestoreFocus
                disableEnforceFocus
                slotProps={{
                  list: {
                    'aria-labelledby': buttonId,
                  },
                  root: {
                    // Forces the backdrop click-away mechanism to wait for the end of the touch
                    touchEvent: 'onTouchEnd',
                    disableAriaHidden: true,
                  },
                }}
              >
                <MUIMenuItem onClick={handleClose}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: 2 }}>
                    <ImportExportDataPanel items={items} setItems={setItems}/>
                  </Box>
                </MUIMenuItem>
                <Divider />
                <MUIMenuItem onClick={handleClose}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', gap: 2 }}>
                    <CloudDataPanel items={items} setItems={setItems} firebaseApp/>
                  </Box>
                </MUIMenuItem>
                {/* {onDuplicate && <MenuItem onClick={(e) => handleDuplicateMenuItemClicked(e)}
                                          onMouseDown={(e) => e.stopPropagation()}
                                          onPointerDown={(e) => e.stopPropagation()}
                                          onTouchStart={(e) => e.stopPropagation()}
                                          onTouchEnd={(e) => e.stopPropagation()}
                                          component="button" // 💡 Forces the browser to treat it strictly as a local code hook
                                          type="button"      // 💡 Blocks it from acting as a form submit button> 
                                          >
                                          <ListItemIcon><ContentCopy fontSize='20px'/></ListItemIcon>
                                          Duplicate
                                </MenuItem>} */}
              </MUIMenu>
              <div className="App-User">
                <button onClick={handleLogOutCLick}>Sign Out</button>
              </div>
            </Box>
          </div>
        </Box>
        <Box component="main" sx={{ flexGrow: 1, width: '100%', display: 'flex', flexDirection: 'row', minHeight: 0, overflow: 'hidden'}}>
          <div className="App-MainPanel">
            <Box
              component="nav"
              sx={{
                display: { xs: 'none', md: 'flex' },
              }}
            >
              <div className="App-NavPanel">
                <div className="App-Menu">
                  {/* <div className="App-MenuHeader"> */}
                    {/* {!navMenuCollapsed && <label className="App-LogoText"> Flow through life...   </label> } */}

                    {/* <button className="sb-button" onClick={() => setNavMenuCollapsed(!navMenuCollapsed)}>
                    {navMenuCollapsed && ">|"} {!navMenuCollapsed && "|<"}
                    </button> */}
                  {/* </div> */}
                  <div className="App-NavMenu" >
                    <Sidebar  collapsed={navMenuCollapsed} collapsedWidth="70px" width="195px" rootStyles={{
                      
                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px'
                      
                      }}>
                      <Menu>
                        <MenuItem icon={<HomeOutlined/>} component={<Link to="/Home" />}>Home</MenuItem>
                        {/* <MenuItem>Dashboard </MenuItem> */}
                        
                        <SubMenu icon={<FormatListNumbered/>} label="Schedule">
                          <MenuItem component={<Link to="/Schedule" />}>Today</MenuItem>
                          <MenuItem>Tomorrow</MenuItem>
                          <MenuItem>This Week</MenuItem>
                          {/* <MenuItem>Next Week</MenuItem>
                          <MenuItem>This Month</MenuItem> */}
                        </SubMenu>
                      </Menu>
                    </Sidebar>
                    <p/>
                    <Sidebar collapsed={navMenuCollapsed} collapsedWidth="70px" width="195px" rootStyles={{
                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px'
                      }}>
                      <Menu label="Goals & Tasks">
                        {/* <MenuItem>Overdue </MenuItem> */}
                        <MenuItem icon={<EmojiEventsOutlined/>} component={<Link to="/Goals" />}>Goals</MenuItem>              
                        <SubMenu icon={<ChecklistRtl/>} label="Tasks">              
                          <MenuItem component={<Link to="/Tasks" />}>All</MenuItem>
                          <SubMenu label="New" component={<Link to="/Tasks/New" />}>
                            <MenuItem component={<Link to="/Tasks/New" />}>Captured </MenuItem>
                            {/* <MenuItem>Assigned </MenuItem> */}
                          </SubMenu>
                          <MenuItem component={<Link to="/Tasks/Processing" />}>Processing</MenuItem>
                          <SubMenu label="Ready" component={<Link to="/Tasks/Ready" />}>              
                            <MenuItem>Today</MenuItem>
                            <MenuItem>Tomorrow</MenuItem>
                            <MenuItem>This Week</MenuItem>
                            <MenuItem>Next Week</MenuItem>
                            <MenuItem>This Month</MenuItem>
                          </SubMenu>
                          <MenuItem component={<Link to="/Tasks/Scheduled" />}>Scheduled</MenuItem>
                          <MenuItem component={<Link to="/Tasks/In_Progress" />}>In Progress</MenuItem>
                        </SubMenu>
                        <MenuItem icon={<History/>} component={<Link to="/Tasks/Recent" />}>Recent</MenuItem>
                        {/* <MenuItem>Recent </MenuItem> */}
                      </Menu>
                      {/* <p/> */}
                    </Sidebar>
                    <p/>
                    <Sidebar  collapsed={navMenuCollapsed} collapsedWidth="70px" width="195px" rootStyles={{

                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                      maxHeight: '100vh',
                      borderRadius: '7px'
                      
                      }}>
                      <Menu>
                        <SubMenu icon={<LandscapeOutlined/>} label="Planning">
                          <SubMenu  label="Yearly">
                            <MenuItem component={<Link to="/Planning/Yearly/This_Year" />}>This Year</MenuItem>
                            <MenuItem component={<Link to="/Planning/Yearly/Next_Year" />}>Next Year</MenuItem>
                            <MenuItem component={<Link to="/Planning/Yearly/Year-Hence" />}>Year-Hence</MenuItem>
                          </SubMenu>
                          <SubMenu  label="Quarterly">
                            <MenuItem component={<Link to="/Planning/Quarterly/This_Quarter" />}>This Quarter</MenuItem>
                            <MenuItem component={<Link to="/Planning/Quarterly/Next_Quarter" />}>Next Quarter</MenuItem>
                            <MenuItem component={<Link to="/Planning/Quarterly/Quarter-Hence" />}>Quarter-Hence</MenuItem>
                          </SubMenu>
                          <SubMenu  label="Monthly">
                            <MenuItem component={<Link to="/Planning/Monthly/This_Month" />}>This Month</MenuItem>
                            <MenuItem component={<Link to="/Planning/Monthly/Next_Month" />}>Next Month</MenuItem>
                            <MenuItem component={<Link to="/Planning/Monthly/Month-Hence" />}>Month-Hence</MenuItem>
                          </SubMenu>
                          <SubMenu  label="Weekly">
                            <MenuItem component={<Link to="/Planning/Weekly/This_Week" />}>This Week</MenuItem>
                            <MenuItem component={<Link to="/Planning/Weekly/Next_Week" />}>Next Week</MenuItem>
                            <MenuItem component={<Link to="/Planning/Weekly/Week-Hence" />}>Week-Hence</MenuItem>
                          </SubMenu>
                        </SubMenu>
                        <SubMenu  icon={<EditCalendarOutlined/>} label="Scheduling">
                          <MenuItem component={<Link to="/Scheduling/Today" />}>Today</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Tomorrow" />}>Tomorrow</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Next_Three_Days" />}>Next Three Days</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/This_Week" />}>This Week</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Next_Week" />}>Next Week</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Week-Hence" />}> Week-Hence</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/This_Month" />}>This Month</MenuItem>
                          <MenuItem component={<Link to="/Scheduling/Month-Hence" />}>Month-Hence</MenuItem>
                        </SubMenu>
                        <SubMenu icon={<ManageSearchOutlined/>} label="Review">
                          <MenuItem component={<Link to="/Review/Daily" />}>Daily</MenuItem>
                          <MenuItem component={<Link to="/Review/Weekly" />}>Weekly</MenuItem>
                          <MenuItem component={<Link to="/Review/Monthly" />}>Monthly</MenuItem>
                          <MenuItem component={<Link to="/Review/Quarterly" />}>Quarterly</MenuItem>
                          <MenuItem component={<Link to="/Review/Yearly" />}>Yearly</MenuItem>
                        </SubMenu>              
                        {/* <MenuItem>Search</MenuItem> */}
                      </Menu>
                    </Sidebar>
                    {/* <Sidebar collapsed={navMenuCollapsed} collapsedWidth="50px" width="175px">
                      <Menu>
                        <SubMenu label="Projects">
                          <MenuItem>Recent </MenuItem>
                        </SubMenu>
                        <SubMenu label="Systems">
                        <MenuItem>Strength & Fitness </MenuItem>
                          <MenuItem>Nutrition </MenuItem>
                          <MenuItem>Cleaning </MenuItem>
                          <MenuItem>Maintenance </MenuItem>
                          </SubMenu>
                          <MenuItem>Filters & Labels </MenuItem>
                        <MenuItem>Templates </MenuItem>
                        </Menu>
                    </Sidebar> */}
                    <p/>
                    <Sidebar collapsed={navMenuCollapsed} collapsedWidth="70px" width="195px" rootStyles={{
                      
                      overflowY: 'auto', // Enables vertical scrolling for long menus
                      overflowX: 'hidden', // Prevents horizontal scrollbars
                          maxHeight: '100vh',
                          borderRadius: '7px'
                          
                    }}>
                      <Menu>              
                        {/* <MenuItem>Automation </MenuItem>
                        <MenuItem>Collaboration </MenuItem>
                        <MenuItem>Analytics </MenuItem>
                        <MenuItem>Wiki </MenuItem>
                        <MenuItem>History </MenuItem> */}
                        {/*TODO: Update these to handle no items/ensure they can handle undefined 'items'*/}
                        <SubMenu icon={<ImportExport/>} label="Data">
                          {/* <MenuItem icon={<ImportExport/>}><ImportExportDataPanel items={items} setItems={setItems}/> </MenuItem>
                          <MenuItem icon={<CloudSyncOutlined/>}><CloudDataPanel items={items} setItems={setItems} firebaseApp/> </MenuItem> */}
                          <MenuItem><ImportExportDataPanel items={items} setItems={setItems}/> </MenuItem>
                          <MenuItem><CloudDataPanel items={items} setItems={setItems} firebaseApp/> </MenuItem>
                        </SubMenu>
                      </Menu>
                    </Sidebar>
                  </div>
                </div>
                {navMenuCollapsed && <Button className='App-HideButtons' alignSelf="center" onClick={() => setNavMenuCollapsed(!navMenuCollapsed)} variant="contained"  sx={{  minWidth: '1px', backgroundColor: '#555a5e3f' }} startIcon={<ChevronRight />} />}
                {!navMenuCollapsed && <Button className='App-HideButtons' alignSelf="center" onClick={() => setNavMenuCollapsed(!navMenuCollapsed)} variant="contained"  sx={{  minWidth: '1px', backgroundColor: '#555a5e3f' }} startIcon={<ChevronLeft />} />}
              </div>
            </Box>
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'row', minHeight: 0, overflow: 'hidden' }}>
              <div className="App-TabbedPages">
                <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
                  <Outlet/>
                </Box>
                <Box
                  component="utilitySidebar"
                  sx={{
                    display: { xs: 'none', md: 'block' },
                    zIndex: 1100,
                    minHeight: 0, overflow: 'hidden'
                  }}
                  >
                  <UtilitySidebar items={items} setItems={setItems} selectedItem={selectedItem} setSelectedItem={setSelectedItem}/>
                </Box>
              </div>
            </Box>
            <Box 
              sx={{ 
                pb: 7, 
                position: 'fixed', 
                bottom: 0, 
                left: 0, 
                right: 0,
                display: { xs: 'block', md: 'none' },
                zIndex: 1100 }} 
                elevation={3}
            >
              <MenuFab handleAddTask={createTask}></MenuFab>
            </Box>
            <Box 
              sx={{ 
                pb: 7, 
                position: 'fixed', 
                bottom: 0, 
                left: 0, 
                right: 0,
                display: { xs: 'block', md: 'none' },
                zIndex: 1100 }} 
                elevation={3}
            >
              <SimpleBottomNavigation/>
            </Box>
          </div>
        </Box>
      </Box>

    </div>
  );
}

export default App;
